











import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

@Component
export default class Range extends Vue {
  @VModel({ type: Array, required: true }) model!: Array<number>

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ type: Number }) readonly min!: number

  @Prop({ type: Number }) readonly max!: number

  @Prop({ type: Number, default: 1 }) readonly step!: number
}
